import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from './WebsiteNavbar.module.css';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Features', href: '/#features' },
  // { label: 'Pricing', href: '/pricing' },
  { label: 'Contact', href: '/contact-us' },
];

const WebsiteNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleToggle = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  const isActive = (href) => {
    if (href === '/') return location.pathname === '/' && !location.hash;
    if (href.includes('#')) {
      return location.pathname === '/' && location.hash === href.replace('/', '');
    }
    return location.pathname === href;
  };

  const handleHashLink = (e, href) => {
    e.preventDefault();
    closeMenu();
    const [path, hash] = href.split('#');
    const targetPath = path || '/';

    if (location.pathname === targetPath) {
      // Already on the page — just scroll to the element
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Navigate to the page — ScrollToTop will handle the hash scroll
      navigate(`${targetPath}#${hash}`);
    }
  };

  const renderLink = (link, className) => {
    const activeClass = isActive(link.href) ? styles['navbar__link--active'] : '';
    if (link.href.includes('#')) {
      return (
        <a
          key={link.label}
          href={link.href}
          className={`${className} ${activeClass}`}
          onClick={(e) => handleHashLink(e, link.href)}
        >
          {link.label}
        </a>
      );
    }
    return (
      <Link
        key={link.label}
        to={link.href}
        className={`${className} ${activeClass}`}
        onClick={closeMenu}
      >
        {link.label}
      </Link>
    );
  };

  return (
    <header className={styles['navbar-wrapper']}>
      <nav className={styles.navbar}>
        <div className={styles.navbar__logo}>
          <Link to="/">
            <img src="/assets/website/navbar-logo.svg" alt="Ogiso" width="120" height="45" />
          </Link>
        </div>

        <div className={styles.navbar__links}>
          {navLinks.map((link) => renderLink(link, styles.navbar__link))}
        </div>

        <div className={styles.navbar__buttons}>
          <Link to="/login" className={`${styles.navbar__btn} ${styles['navbar__btn--secondary']}`}>
            Login
          </Link>
          <Link to="/book-demo" className={`${styles.navbar__btn} ${styles['navbar__btn--primary']}`}>
            Book a demo
          </Link>
        </div>

        <button
          className={`${styles['navbar__mobile-toggle']} ${menuOpen ? styles.active : ''}`}
          aria-label="Toggle menu"
          onClick={handleToggle}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      <div className={`${styles['navbar__mobile-menu']} ${menuOpen ? styles.open : ''}`}>
        <div className={styles['navbar__mobile-links']}>
          {navLinks.map((link) => renderLink(link, styles['navbar__mobile-link']))}
        </div>
        <div className={styles['navbar__mobile-buttons']}>
          <Link
            to="/login"
            className={`${styles.navbar__btn} ${styles['navbar__btn--secondary']}`}
            onClick={closeMenu}
          >
            Login
          </Link>
          <Link
            to="/book-demo"
            className={`${styles.navbar__btn} ${styles['navbar__btn--primary']}`}
            onClick={closeMenu}
          >
            Book a demo
          </Link>
        </div>
      </div>
    </header>
  );
};

export default WebsiteNavbar;
